<template class="wrapper">
  <router-view :data-theme="theme" />
  <div class="focus-trap-wrapper previewModal--wrapper detail-modal" :class="{ show: isActive }" v-if="infoMovie">
    <InfoMovie :click="hideInfo" :item="infoMovie" />
  </div>
  <div @click.self="hideInfo" :class="{ showTemplate: isActive }" class="previewModal--backDrop"></div>

  <popup-container />
  <mobile-choose :isVisibleMobileModal="isVisibleMobileModal" :closeModal="() => (isVisibleMobileModal = false)" />
</template>

<script>
import { actionTypes, mutationTypes } from '@/store/modules/auth';
import { actionTypes as configActionTypes } from '@/store/modules/config';
import { mapState } from 'vuex';
import InfoMovie from '@/components/InfoMovie/InfoMovie';
import './style.scss';
import getChatProvider from '@/helpers/chats';
import { getItem } from '@/helpers/storage';
import { useHead } from '@unhead/vue';
import PopupContainer from '@/components/PopupContainer.vue';
import MobileChoose from '@/components/MobileChoose.vue';

export default {
  name: 'App',
  components: { PopupContainer, InfoMovie, MobileChoose },
  data() {
    return {
      isVisibleMobileModal: false,
    };
  },
  mounted() {
    this.$store.dispatch(actionTypes.getCurrentUser);
    this.$store.dispatch(configActionTypes.loadBrandConfig);
    this.$store.dispatch(configActionTypes.initializeToken);
    this.$store.commit(mutationTypes.setGuidCredentials, getItem('guidCredentials'));
    if (this.isLoggedIn) {
      this.checkIfMobile();
    }
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth?.isLoggedIn,
      infoMovie: (state) => state.infoMovie.data,
      isActive: (state) => state.infoMovie.isActive,
      loading: (state) => !state.config.isConfigLoaded,
      chatProvider: (state) => state.config.chatProvider,
      brandName: (state) => state.config?.brandName,
      theme: (state) => {
        return state.config?.brandName || '';
      },
    }),
  },
  methods: {
    hideInfo() {
      this.$store.commit('handleShowInfoMovie', false);
    },
    checkIfMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      const isMobile = /android|iphone|ipad|ipod|windows phone/i.test(userAgent);

      this.isVisibleMobileModal = isMobile;
    },
  },
  watch: {
    chatProvider: function (provider) {
      try {
        const injectChat = getChatProvider(provider);
        injectChat(this.brandName);
      } catch {
        //
      }
    },
    isLoggedIn(value) {
      if (value) {
        this.checkIfMobile();
      }
    },
    brandName() {
      useHead({
        link: [
          {
            rel: 'icon',
            href: `${this.brandName.toLowerCase()}.png`,
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  overflow-x: hidden;
  width: 100%;
  min-height: 100%;
  margin: 0;
  display: flex;
  padding: 0;
  position: relative;
}

.show {
  opacity: 1;
  visibility: visible;
  transition: all 0.5s;
}

.showTemplate {
  opacity: 0.7;
  visibility: visible;
}
</style>
